module.exports = __webpack_public_path__ + "static/plasticMechanism.7774abd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apps/SLaMAf/plasticMechanism.png
// module id = 846
// module chunks = 185661124034206 206145399751139